import React, { Component } from 'react';
import { purchaseQuery } from './query';
import Loading from '../../components/Loading';
import Message from '../Message';
import BuyMoreEntitiesModal from './modal';
import { withTranslation } from 'react-i18next';

class CustomView extends Component {
    constructor() {
        super();

        this.onBuy = this.onBuy.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.showName = this.showName.bind(this);

        this.state = {
            isOpenModal: false,
            message: '',
            message_tags: '',
            selectedOption: 1,
        };
    }

    openModal() {
        this.setState({
            isOpenModal: true,
        });
    }

    closeModal() {
        this.setState({
            isOpenModal: false,
        });
    }

    deleteMessage() {
        this.setState({ message: '' });
    }

    calculateTotalPrice(selectedAmount) {
        const price = this.props.item.additional_price.find((item, i, arr) => {
            if (i === 0 && selectedAmount > item?.up_to) return false;
            if (i === 0 && selectedAmount <= item?.up_to) return true;
            if (i === arr.length - 1) return true;
            if (selectedAmount > arr[i - 1]?.up_to && selectedAmount <= item.up_to) return true;

            return false;
        })?.unit_amount;

        return price ? price / 100 : 0;
    }

    hasMoreThanThreeDecimals(num) {
        var decimalPart = (num % 1).toString();
        return decimalPart.length > 4;
    }

    toFix(num) {
        return this.hasMoreThanThreeDecimals(num) ? num.toFixed(2) : num;
    }

    async onBuy() {
        const { t } = this.props;
        try {
            this.setState({
                isLoading: true,
            });
            const params = {
                quantity: Number(this.state.customValue) || this.state.selectedOption,
                object_name: this.props.item.object_name,
            };
            const response = await purchaseQuery(params, this.props.csrf_token);
            this.closeModal();
            const data = await response.json();
            if (data.status === 400) {
                this.setState({
                    message_tags: 'error',
                    message: data.message,
                    isLoading: false,
                });
            } else {
                this.setState({
                    message_tags: 'success',
                    message: data.message ?? t('purchase_add_ons.success_message'),
                    isLoading: false,
                    selectedOption: 1,
                    customValue: 0,
                    openCustomInput: false,
                });
            }
        } catch (err) {
            this.setState({
                message_tags: 'error',
                message: t('purchase_add_ons.error_message'),
                isLoading: false,
            });
            console.log(err);
        }
    }

    showName(key) {
        const { t } = this.props;

        const names = {
            content_analysis: t('purchase_add_ons.content_analysis'),
            commerce_analytics: t('purchase_add_ons.commerce_analytics'),
            entities: t('purchase_add_ons.entities'),
            seats: t('purchase_add_ons.seats'),
        };

        return names[key];
    }

    render() {
        const { t } = this.props;
        const price = this.calculateTotalPrice(1);

        return (
            <>
                <div className="mt-16">
                    <div className="purchase-new-entity-container-info">
                        <div className="d-flex justify-content-between w-100 align-items-center">
                            {t('purchase_add_ons.total_price')}
                            <div className="purchase-new-entity-container-info-total">
                                $ {this.toFix(price)} / {this.props.item.current_plan_interval}
                            </div>
                        </div>
                    </div>
                    <div className="purchase-new-entity-container-help">
                        {t('purchase_add_ons.custome_message', {
                            object_name: this.showName(this.props.item.object_name),
                            current_plan_interval: this.props.item?.current_plan_interval,
                        })}
                    </div>
                    <button
                        className="button button-filled button-primary btn d-flex align-items-center justify-content-center mt-10 px-35"
                        onClick={this.openModal}
                        disabled={
                            !this.props.item.additional_price || !price || this.state.isLoading
                        }
                    >
                        {t('purchase_add_ons.buy_now')}
                    </button>
                    {this.state.isLoading && <Loading padding={10} />}
                </div>
                {this.state.message && (
                    <div className="messages">
                        <Message
                            message_tags={this.state.message_tags}
                            message={this.state.message}
                            deleteMessage={this.deleteMessage}
                        />
                    </div>
                )}
                <BuyMoreEntitiesModal
                    object_message={t('purchase_add_ons.custom_object_message')}
                    isOpen={this.state.isOpenModal}
                    onClose={this.closeModal}
                    entityCount={1}
                    onSubmit={this.onBuy}
                    totalPrice={this.toFix(price)}
                    period={this.props.item.current_plan_interval}
                />
            </>
        );
    }
}

export default withTranslation()(CustomView);
